import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {historyMediaStore, recentlyMediaStore} from "../../store/MediaStore";
import ContentWrap from "../../components/layout/ContentWrap";
import InfiniteScroll from "react-infinite-scroller";
import Media from "../../components/media/Media";
import {Button, Col, Container, FormControl, InputGroup, Row} from "react-bootstrap";
import Styles from './HistoryView.module.scss'
import {HISTORY, navigate} from "../../helper/HistoryHelper";
import {MagnifyingGlass} from "react-loader-spinner";
import {MdArrowBackIos} from "react-icons/md";
import moment from "moment/moment";
import CommonHelper from "../../helper/CommonHelper";
import qs from "qs";
import SortDropDown from "../../components/media/SortDropDown";

const store = historyMediaStore;

const SORT_TYPE = {
    id: '등록순',
    view: '조회순',
    like: '인기순',
    hate: '비인기순',
    history: '시청순',
    duration: '재생시간순'
}

@observer
class HistoryView extends Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        store.scrollRef.current.scrollTo(0, store.scrollTop)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(!_.isEqual(this.props.location, prevProps.location)){
            store.searchCondition.replace(CommonHelper.objectToMap(qs.parse(this.props.location.search, { ignoreQueryPrefix: true })));
            store.debounceFetch(true);
        }
    }

    componentWillUnmount() {
    }

    render() {
        return (
            <ContentWrap>
                <div className={Styles.SearchBar}>
                    <Container className={`p-0 d-flex justify-content-between flex-column`}>
                        <div className={Styles.Header}>
                            <div className={Styles.BackButton}
                                 onClick={() => {
                                     HISTORY.goBack();
                                 }}
                            >
                                <MdArrowBackIos color={'#fff'} size={`1.5rem`}/>
                            </div>
                            <div className={Styles.Title}>
                                시청기록
                            </div>
                            <div>

                            </div>
                        </div>
                        <div className={`d-flex `}>
                            <div className={`d-flex flex-grow-1 text-nowrap`}>
                                <SortDropDown store={store}
                                              option={SORT_TYPE}
                                />
                            </div>
                            <div>
                                <InputGroup>
                                    <FormControl size={'sm'}
                                                 value={store.searchCondition.get('keyword')||''}
                                                 onChange={e => {
                                                     store.searchCondition.set('keyword', e.target.value)
                                                 }}
                                                 onKeyDown={e => {
                                                     if (e.key === 'Enter') {
                                                         store.search(this.props.location.pathname)
                                                     }
                                                 }}
                                    />
                                    <Button variant={"outline-light"} size={'sm'}
                                            onClick={() => {
                                                store.search(this.props.location.pathname)
                                            }}
                                    >
                                        검색
                                    </Button>
                                </InputGroup>
                            </div>
                        </div>
                    </Container>
                </div>
                <div className={Styles.Content}
                     ref={store.scrollRef}
                     onScroll={store.onScrollHandler}
                >
                    <InfiniteScroll
                        loadMore={(page) => {
                            store.debounceFetch(false)
                        }}
                        hasMore={store.files.length < store.count}
                        loader={
                            <div key={"a"}>
                            </div>
                        }
                        useWindow={false}
                        threshold={5}
                    >
                        <Container className={`p-0`}>
                            <Row>
                                {
                                    !store.isFetching && store.files.length < 1 &&
                                    <div className={`align-items-center justify-content-center d-flex p-5`}>
                                        검색 결과가 없습니다.
                                    </div>
                                }
                                {
                                    store.files.map(file => {
                                        return (
                                            <Col sm={12} md={4} xl={3} key={`HOME-${file.id}`}>
                                                <Media file={file}
                                                       onClick={(file)=>{
                                                           navigate(`/main/history/${file?.folder?.id}/${file.id}`)
                                                       }}
                                                       dateLabel={`${moment(file?.history?.created).fromNow()} 시청함`}
                                                />
                                            </Col>
                                        )
                                    })
                                }
                                {
                                    store.isFetching &&
                                    <Col sm={12} md={12} xl={12} className={`d-flex justify-content-center align-items-center p-5`}>
                                        <MagnifyingGlass
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="magnifying-glass-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="magnifying-glass-wrapper"
                                            glassColor="#c0efff"
                                            color="#afafaf"
                                        />

                                    </Col>
                                }
                            </Row>
                        </Container>
                    </InfiniteScroll>
                </div>
            </ContentWrap>
        );
    }
}

HistoryView.propTypes = {};

export default HistoryView;
